exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".date-range-picker-container{margin:5px;max-width:500px}.date-range-picker-container .date-range-picker{display:flex;align-items:center}.date-range-picker-container .error-message{font-size:12px;color:red;padding-left:6px}\n", ""]);

